import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as HamburgerIcon } from "../../assets/icons/hamburger.svg";
import useReaderStore from "../../context/readerStore";
import "./FloatingToolbar.css";

/**
 * Left-side floating TOC trigger (v2).
 * Replaces the previous annotation floating bar on desktop/tablet.
 * Mobile continues to use MobileBottomBar.
 * When TOC is open, this control docks into the sidebar header.
 */
const FloatingToolbar = () => {
  const { t } = useTranslation();
  const { isTocSidebarOpen, toggleTocSidebar } = useReaderStore();

  const handleToggleTocSidebar = useCallback(() => {
    const wasOpen = isTocSidebarOpen;
    toggleTocSidebar();
    if (!wasOpen) {
      setTimeout(() => {
        document
          .querySelector(".table-of-contents h3")
          ?.focus({ preventScroll: true });
      }, 100);
    }
  }, [isTocSidebarOpen, toggleTocSidebar]);

  return (
    <div
      className={`floating-toolbar floating-toolbar--toc-only${
        isTocSidebarOpen ? " is-docked" : ""
      }`}
      role="toolbar"
    >
      <button
        className="icon-button"
        onClick={handleToggleTocSidebar}
        aria-pressed={isTocSidebarOpen}
        aria-expanded={isTocSidebarOpen}
        aria-label={
          isTocSidebarOpen
            ? t("rightToolbar.hideToc")
            : t("rightToolbar.showToc")
        }
        title={
          isTocSidebarOpen
            ? t("rightToolbar.hideToc")
            : t("rightToolbar.showToc")
        }
      >
        <HamburgerIcon width={18} height={18} aria-hidden="true" />
      </button>
    </div>
  );
};

export default FloatingToolbar;
